import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonWithSpinner from "../ButtonWithSpinner";
import Translate from "../../utils/Translate";
import { TextField } from "@mui/material";
import { useState } from "react";

export default function ConfirmDeleteUnsignedPermitDialog({ open, operatorName, onNo, onYes }) {
  const [message, setMessage] = useState("");
  return (
    <div>
      <Dialog
        className="smallCourseDialog"
        open={open}
        onClose={async () => await onNo()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{Translate.get("Delete")}</DialogTitle>
        <DialogContent style={{ whiteSpace: "pre-wrap" }}>
          <DialogContentText>{Translate.get("DeletePermitFor") + " " + operatorName}</DialogContentText>
          <TextField
            sx={{ marginTop: "24px" }}
            fullWidth
            label={`${Translate.get("Message")} (${Translate.get("Optional")})`}
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            inputProps={{ maxLength: 200 }}
          />
        </DialogContent>
        <DialogActions>
          <ButtonWithSpinner onClick={async () => await onNo()}>{Translate.get("No")}</ButtonWithSpinner>
          <ButtonWithSpinner onClick={async () => await onYes(message)} variant="contained" autoFocus>
            {Translate.get("Yes")}
          </ButtonWithSpinner>
        </DialogActions>
      </Dialog>
    </div>
  );
}
